module.exports = __webpack_public_path__ + "img/main-facility-p-store.67acef73.jpg";